// dialog-message-error.tsx
import { Link } from '@tanstack/react-router'

import { Button, ButtonLoading } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'

interface DialogMessageErrorProps {
  open: boolean
  setOpen: (open: boolean) => void
  msg: any
}

enum MessageError {
  'PROFIL_NOT_FULLFILL' = 'Progres Biodata kamu harus sudah Lengkap terlabih dahulu untuk melamar pekerjaan!',
  'ALREADY_APPLY' = 'Kamu tidak bisa melamar karena kamu sedang dalam proses seleksi pekerjaan yang lain! Untuk saat ini, kamu hanya bisa melamar satu pekerjaan sampai proses seleksimu berhasil/gagal!',
}

function DialogMessageError({ open, setOpen, msg }: DialogMessageErrorProps) {
  if (msg == MessageError.PROFIL_NOT_FULLFILL) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-2xl">
          <DialogHeader>
            {/* <DialogTitle>Select image</DialogTitle> */}
            <DialogDescription>
              <div className="flex flex-col items-center gap-4">
                <div className="flex w-72 justify-center text-center text-lg">
                  Oops.. Anda belum bisa melamar pekerjaan sekarang.
                </div>
                <div>
                  <img src="/img/landing/error-profil-not-fullfill.svg" />
                </div>
                <div className="px:16 flex justify-center text-center text-lg sm:px-24">
                  Harap lengkapi Biodata terlebih dahulu agar dapat melamar
                  pekerjaan.
                </div>
              </div>
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="mt-6 flex gap-4 sm:justify-center sm:gap-0">
            <Button variant={'outline'} onClick={() => setOpen(false)}>
              Kembali
            </Button>
            <Button className="w-full sm:w-auto" asChild>
              <Link to="/profile">Lengkapi Biodata</Link>
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }

  if (msg == MessageError.ALREADY_APPLY) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-2xl">
          <DialogHeader>
            {/* <DialogTitle>Select image</DialogTitle> */}
            <DialogDescription>
              <div className="flex flex-col items-center gap-4">
                <div className="flex w-72 justify-center text-center text-lg">
                  Oops.. Anda Sudah Melamar di Pekerjaan lain
                </div>
                <div>
                  <img src="/img/landing/error-profil-not-fullfill.svg" />
                </div>
                <div className="flex justify-center px-24 text-center text-lg">
                  Mohon tunggu sampai proses sebelumnya selesai terlebih dahulu
                </div>
              </div>
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="mt-6 flex sm:justify-center">
            <Button variant={'outline'} onClick={() => setOpen(false)}>
              Tutup
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }
}

export default DialogMessageError
